import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";

var RouteManager = /*#__PURE__*/function () {
  function RouteManager() {
    _classCallCheck(this, RouteManager);

    _defineProperty(this, "_standard", void 0);

    _defineProperty(this, "_isReady", false);
  }

  _createClass(RouteManager, [{
    key: "isReady",
    get: function get() {
      return this._isReady;
    }
  }, {
    key: "standard",
    get: function get() {
      return this._standard;
    }
  }, {
    key: "registerStandardAppRouters",
    value: function registerStandardAppRouters(standardRouters) {
      this._standard = standardRouters;
      this._isReady = true;
    }
  }]);

  return RouteManager;
}();

export var routeManager = new RouteManager();